<template>
  <div class="sidebar">
    <nav class="sidebar-nav">
      <div class="avatar">
        <div class="l-avatar-wrap pointer">
          <img src="../../assets/img/avatar.png" class="l-avatar profile" />
        </div>
        <!--        <span>{{ userData.first_name }}<br />{{ userData.last_name }}</span>-->
        <button type="button" class="btn btn-link text-white" @click="logout">
          <i class="fa fa-sign-out text-white" />
        </button>
      </div>
      <ul class="tier-1">
        <li>
          <router-link class="sidebar-item" to="/posts">
            <div class="md-icon md-icon-blog" />
            <span class="l-menu-title">Posts</span>
          </router-link>
        </li>
        <li>
          <router-link class="sidebar-item" to="/categories">
            <div class="md-icon md-icon-categories" />
            <span class="l-menu-title">Categories</span>
          </router-link>
        </li>
        <li>
          <router-link class="sidebar-item" to="/tags">
            <div class="md-icon md-icon-tags" />
            <span class="l-menu-title">Tags</span>
          </router-link>
        </li>
        <li>
          <router-link class="sidebar-item" to="/reviews">
            <div class="md-icon md-icon-reviews" />
            <span class="l-menu-title">Reviews</span>
          </router-link>
        </li>
        <li>
          <router-link class="sidebar-item" to="/git">
            <div class="md-icon md-icon-git" />
            <span class="l-menu-title">Git</span>
          </router-link>
        </li>

        <li>
          <router-link class="sidebar-item logo" to="/" />
        </li>
      </ul>
    </nav>

    <!-- Mobile menu   -->
    <nav class="mobile navbar navbar-light navbar-1">
      <div class="d-flex align-items-center menu-item-wrapper">
        <button class="navbar-toggler" @click="toggleMenu">
          <i v-if="!mobileMenu" class="fa fa-bars hamburger-icon" />
          <svg
            v-else
            width="30"
            height="30"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
              fill="white"
            />
          </svg>
        </button>

        <div class="avatar">
          <div class=" pointer">
            <img src="../../assets/img/logo.png" width="90" />
          </div>
        </div>
      </div>

      <transition name="slide">
        <div class="r-modal-mask" v-if="mobileMenu">
          <MobileSidenav
            v-scroll-lock="mobileMenu"
            class="mobile-sidebar"
            @close="toggleMenu"
            @clickLink="toggleMenu"
            @logout="logout"
          />
        </div>
      </transition>
    </nav>
  </div>
</template>

<script>
import MobileSidenav from "./MobileSidenav.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "LayoutSidebar",
  components: {
    MobileSidenav
  },
  data: () => ({
    mobileMenu: false
  }),
  computed: {
    ...mapGetters({
      userData: "userData"
    })
  },
  methods: {
    ...mapActions(["authLogout"]),
    async logout() {
      await this.authLogout().then(() => {
        this.$router.push("/");
      });
    },
    toggleMenu() {
      this.mobileMenu = !this.mobileMenu;
    }
  }
};
</script>

<style lang="scss" scoped>
.profile {
  display: inline-block;
}
.notify-badge {
  font-size: 12px;
  position: absolute;
  right: 15px;
  top: 17px;
  background: #3db152;
  text-align: center;
  border-radius: 30px 30px 30px 30px;
  color: white;
  padding: 2px 5px;
}
.sidebar {
  width: 72px;
  background-color: #006266;
  position: relative;
  z-index: 1000;
  min-height: 100vh;
}
.sidebar-nav .logo {
  width: 100%;
  background: url(../../assets/img/logo.png);
  background-size: cover;
  position: absolute !important;
  bottom: 24px;
  right: 12px;

  &:hover {
    background-color: transparent;
  }
}

.sidebar-nav {
  z-index: 50;
  background-color: #006266;
  color: white;
  min-height: 100%;
}

.sidebar-nav h1 {
  padding: 0;
  color: #fff;
}

.sidebar-nav ul {
  padding: 0;
}

.sidebar-nav ul li {
  list-style-type: none;
}

.tier-1 .sidebar-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 72px;
  width: 72px;
  margin: 0;
  cursor: pointer;
  text-align: center;
  position: relative;
  background-color: transparent;
  color: rgba(255, 255, 255, 0.6);
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;

  & .md-icon {
    opacity: 0.85;
  }
}

.tier-1 .sidebar-item:hover {
  text-decoration: none;
  background-color: rgba(255, 255, 255, 0.1);

  & .md-icon {
    opacity: 1;
  }
}

.tier-1 .sidebar-item-sub:hover {
  background-color: #204ecc;
}

.tier-2,
.tier-3 {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  padding: 28px 12px !important;
  z-index: -1;
}

.tier-2 {
  top: 0;
  left: 72px;
  padding: 28px 12px;
  min-width: 220px;
  box-sizing: border-box;
  height: 100%;
  transition: all 300ms ease;
}

.tier-3 {
  background-color: #1f419e;
  width: 232px;
  border-left: 12px solid #204ecc;
  top: 0;
  left: 280px;
  height: 100vh;
  position: fixed;
  transition: all 400ms ease;
}

.tier-3 .sidebar-item {
  position: inherit !important;
}

.sidebar-item-sub {
  position: inherit !important;
}

.tier-2-background-wrap {
  position: absolute;
  top: 0;
  left: -148px;
  min-width: 220px;
  box-sizing: border-box;
  height: 100%;
  background-color: #204ecc;
  transition: left 300ms ease-in-out;
  z-index: -1;
}

.tier-2-overlay:hover .tier-2-background-wrap {
  visibility: visible;
  opacity: 1;
  left: 72px;
}

.sidebar-item-sub:hover > .tier-2 {
  visibility: visible;
  opacity: 1;
}
.tier-2 .sidebar-item:hover .tier-3 {
  visibility: visible;
  opacity: 1;
}

.tier-2 .sidebar-item,
.tier-3 .sidebar-item {
  color: #606266;
  padding: 8px 10px;
  border-radius: 4px;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  min-width: 106px;
  text-align: left;
  width: 100%;
  height: auto;
  background-color: transparent;
  opacity: 0.8;
  display: flex;
  margin-bottom: 4px;
  align-items: center;
  justify-content: flex-start;
  text-decoration: none;

  & .md-icon {
    width: 17px;
    height: 15px;
    margin-right: 12px;
  }

  .l-sidebar-menu-title {
    font-size: 14px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.71;
    letter-spacing: normal;
    color: #ffffff;
  }

  &:hover {
    opacity: 1;
    background-color: rgba(255, 255, 255, 0.08);
  }
}

.sidebar-item:hover .l-menu-title {
  display: block;
}

.l-menu-title {
  background-color: #006266;
  border-radius: 5px;
  color: #fff;
  padding: 7px 10px;
  position: absolute;
  right: -112px;
  top: 22px;
  -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
  display: none;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  min-width: 106px;
  text-align: center;

  &:before {
    border-top: 4px solid transparent;
    border-right: 4px solid #006266;
    border-bottom: 4px solid transparent;
    content: "";
    left: -4px;
    top: 10px;
    position: absolute;
  }
}

.sidebar-item-sub {
  position: inherit;
}

.avatar {
  z-index: 100;
  text-align: center;
  padding-top: 20px;
  padding-bottom: 60px;
  background-color: #006266;
  height: 19vh;
}

.l-avatar-wrap {
  width: 48px;
  height: 48px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar span {
  font-size: 12px;
  color: #f3f4f5;
  display: block;
}

.avatar button {
  display: block;
  margin: 0 auto;
}

.l-avatar {
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: block;
}
.hamburger-icon {
  font-size: 26px;
  color: white;
}
.navbar-light .navbar-toggler {
  border: none;
  background: transparent;
}
.mobile {
  display: none;
}
.menu-item-wrapper {
  min-height: 72px;
  justify-content: space-between;
}
@media screen and (max-width: 630px) {
  .mobile {
    display: block !important;
  }
  .avatar {
    padding: 0 !important;
    height: auto !important;
  }
  .sidebar-nav {
    display: none;
  }
  .sidebar {
    width: 100% !important;
    min-height: 72px !important;
    position: absolute;
  }
}
</style>
